var getSid = function () {
  // 测试代码
  if (typeof __urlParams !== 'undefined' && __urlParams.sid ) {
    return __urlParams.sid;
  }
  var cookies = document.cookie.split('; ');
  for (var i = 0, iLen = cookies.length; i < iLen; i++) {
    if (cookies[i].split('=')[0] == 'sid') {
      return decodeURIComponent(cookies[i].split('=')[1]);
    }
  }
  return '';
};

var getDefaultInfo = function () {
  return {
    type: 'unknow'
  };
};

// readyState 0 未认证 1 认证中 2 认证成功 3 认证失败
var Gateway = function (message) {
  this.message = message;
  this.init();
};

Gateway.prototype = {
  init: function () {
    this.initData();
    this.initPromise();
    this.initEvent();
  },

  getSid: function () {
    return this.userinfo.sid || getSid();
  },

  initData: function () {
    this.userinfo = getDefaultInfo();
    // 1 准备中
    this.readyState = 0;
  },

  initPromise: function () {
    if (this.reject) {
      this.reject('close');
    }

    this.promise = new Promise (function (resolve, reject) {
      this.resolve = resolve;
      this.reject = reject;
    }.bind(this));

    // 为了屏蔽对promise错误没有捕捉的抛错，因为有时候捕捉是在另外一个流程里，是接上去的。
    this.promise.then(function() {}).catch(function(e) {});
  },

  initEvent: function () {
    this.message.on('close:gateway', '', this.unregister.bind(this));
    this.message.on('open:gateway', '', this.register.bind(this));
  },

  unregister: function () {
    this.userinfo = getDefaultInfo();
    this.readyState = 0;
    this.initPromise();
  },

  register: function () {
    this.readyState = 1;
    this.message.send('gateway', 101, {
      sid: this.getSid(),
      nickname: this.message.options.nickname,
      avatar: this.message.options.avatar
    }).then(function (result) {
        if (result.code == 1) {
          this.userinfo = result.data;
          this.readyState = 2;
          this.resolve(result.data);
        } else {
          this.readyState = 3;
          this.reject(result);
        }
      }.bind(this), function (error) {
        this.readyState = 3;
        this.reject(error);
      }.bind(this));
  },

  getUser: function () {

    return this.promise;
  }

};

module.exports = Gateway;


// WEBPACK FOOTER //
// /Users/zhujian/Desktop/code/live_system/live/modules/f.compenont.messageCenter/lib/gateway.js